<template>






  <div id="app">

    <el-container>
      <el-header>
        <div>
          <h1> Freebeat Dashboard Demo  </h1>
        </div>
      </el-header>
      <el-container>
        <el-aside width="240px">
          <Menu>
          </Menu>
        </el-aside>
        <el-container>
          <el-main>

            <router-view></router-view>

          </el-main>

        </el-container>
      </el-container>
      <el-footer> Freebeat Dashboard Demo </el-footer>
    </el-container>
  </div>






</template>

<script>

import Menu from './components/menu.vue';


export default {
  name: 'App',
  components: {


    Menu
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1a2734;
  margin-top: 5px;
}



.el-header,
.el-footer {
  background-color: rgb(84, 92, 100);
  color: #333;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  line-height: 40px;
}

body>.el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>
